import React, {PureComponent} from 'react'
import styled from 'styled-components'
import {Header, Icon, CardView} from '../components'
import get from 'lodash/get'
import { toast } from 'react-toastify'
import axios from 'axios'
// import Chart from 'react-google-charts'


const Container = styled.div`
  width: 100%;
  padding: 50px 16px 16px 16px; 
  max-width: 800px;
  margin: auto;
`

const ButtonWrapper = styled.div`
  padding: 25px 15px 20px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Button = styled.button`
  padding: ${props=> props.padding ? props.padding : ' 10px 25px' };
  background: #020266;
  border: 1px solid #020266;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  margin: 0 5px;
`


class Home extends PureComponent{
  state={
    component:{},
    componentdata:{}
  }
  componentDidMount=async()=>{

   
      const {data : componentdata}= await axios.get('dashboard/Pmayu2/all');
     

  const Houses_Sanctioned=  (Number(get(componentdata.data[0], "sanctioned") || 0) + Number(get(componentdata.data[1], "sanctioned") || 0)).toFixed(2)
const Investment=  (Number(get(componentdata.data[0], "overall") || 0) + Number(get(componentdata.data[1], "overall") || 0)).toFixed(2)
const Central_Assistance_Committed =  (Number(get(componentdata.data[0], "committed") || 0) + Number(get(componentdata.data[1], "committed") || 0)).toFixed(2)
const Central_Assistance_Release= (Number(get(componentdata.data[0], "released") || 0) + Number(get(componentdata.data[1], "released") || 0)).toFixed(2)
const House_Grounded= (Number(get(componentdata.data[0], "grounded") || 0) + Number(get(componentdata.data[1], "grounded") || 0)).toFixed(2)
const House_Completed= (Number(get(componentdata.data[0], "completed") || 0) + Number(get(componentdata.data[1], "completed") || 0)).toFixed(2)
// const Houses_New_Technology= (Number(get(componentdata.data[0], "sanctioned") || 0) + Number(get(componentdata.data[1], "sanctioned") || 0)).toFixed(2)
const Houses_New_Technology=15.60

this.setState({ component:{ Houses_Sanctioned, Investment, Central_Assistance_Committed, Central_Assistance_Release, House_Grounded, House_Completed, Houses_New_Technology} })


      // fetch('https://pmaymis.gov.in/api/PMAY_Services/Get_Ministry_Dashboard_Data')
      // .then(response => response.json())
      // .then(data => this.setState({ component:get(data,'0.Value.0') }))
      // .catch(error=> {
      //   toast.error('Internal Server error.')
      // })
  }
  render(){
  const {component} = this.state
  console.log('component-render--->', component)
    return(
      <React.Fragment>
      <Header/>
      <Container>
      <ButtonWrapper>
        <Button padding='5px 20px' onClick={()=> this.props.history.push('/form')}>Go To Inspection Form <Icon icon='rightArrow' color='#fff'/></Button>
      </ButtonWrapper>

      <CardView value={get(component,'Houses_Sanctioned')} ext={'Lakh'}/>
      <CardView iconName='rupee' name='Investment' iconBg='#06cccc' ext={'Lakh Cr.'} rupeeIcon={true} value={get(component,'Investment')}/>
      <CardView iconName='houses' iconWidth={37} name='CA Committed'   iconBg='#9acd32' rupeeIcon={true} ext={'Lakh Cr.'}  value={get(component,'Central_Assistance_Committed')} />
      <CardView iconName='reports' name='CA Released' iconBg='#b01195' ext={'Cr.'} rupeeIcon={true} value={get(component,'Central_Assistance_Release',0).toLocaleString()} />
      <CardView iconName='houseGround' iconWidth={37} name='Houses Grounded' iconBg='#ff7f50' ext={'Lakh'} value={get(component,'House_Grounded')} />
      <CardView iconName='houseComplate' iconWidth={37} name='Houses Completed' iconBg='#2e8b57' ext={'Lakh'} value={get(component,'House_Completed')} />
      <CardView iconName='houseNewTech' iconWidth={30} name='Houses New Technology' iconBg='#6a5acd' ext={'Lakh'} value={get(component,'Houses_New_Technology')} />
      {/* <Chart
      width={'100%'}
      height={'280px'}
      chartType="PieChart"
      loader={<div style={{opacity:0.1, display: 'flex', justifyContent:'center'}}><img style={{maxWidth: 500, width: '100%', margin: 'auto'}} alt='chart' src={require('../static/chart-1.png')}/></div>}
      data={[
        ['Task', 'Hours per Day'],
        ['Sanctioned : 98,500', 98500],
        ['Grounded : 68,230', 68230],
        ['Completed : 25,500', 25500],
        ['Occupied : 56566', 56566],
      ]}
      options={{
        title: 'PMAY(U) Houses',
        is3D: true,
        backgroundColor: {
        fill: 'transparent',
      },
      chartArea:{
        left: 0,
        right:0,
      }
      }}
      rootProps={{ 'data-testid': '2' }}
    /> */}

    {/* <Chart
  width={'100%'}
  height={'280px'}
  chartType="ComboChart"
  loader={<div style={{opacity:0.1, display: 'flex', justifyContent:'center'}}><img style={{maxWidth: 500, width: '100%', margin: 'auto'}} alt='chart' src={require('../static/chart-2.png')}/></div>}
  data={[
    [
      'Month',
      'Sanctioned',
      'Grounded ',
      'Visited',

    ],
    ['March', 98500, 38230, 2001, ],
    ['April', 98500, 45230, 5006, ],
    ['May', 98500, 50230, 12002, ],
    ['Jun', 98500, 59230, 15050, ],
    ['July', 98500, 68230, 20051, ],
  ]}
  options={{
    title: 'Monthly Project Visit Report',
    vAxis: { title: 'Cups' },
    hAxis: { title: 'Month' },
    seriesType: 'bars',
    series: { 3: { type: 'line' } },
    backgroundColor: {
      fill: 'transparent',
    },
    chartArea:{
      left: 0,
      right:120,
    }
  }}
  rootProps={{ 'data-testid': '1' }}
/> */}

      </Container>
      </React.Fragment>
    )
  }
}

export {Home}